import _sfc_main from "../../components/MediaCenter/MediaCenter.mjs";
import "core-js/modules/es.array.push.js";
import { UPDATE_COMPONENT_MOUNTED, INIT_PRODUCT_PAGE_MOUNT, HANDLE_MC_IMAGE_CLICK, METRICS_CLICK, SET_USE_VERTICAL_ANIMATION, HANDLE_HERO_ZOOM_OPEN, HANDLE_HERO_ZOOM_CLOSE, HANDLE_HERO_ZOOM_IMAGE_CHANGE, HANDLE_UGC_IMAGE_CLICK, SET_CURRENT_UGC_PRODUCT } from "../../store/constants.mjs";
import "bezier-easing";
import "js-cookie";
import "core-js/modules/esnext.set.difference.v2.js";
import "core-js/modules/esnext.set.intersection.v2.js";
import "core-js/modules/esnext.set.is-disjoint-from.v2.js";
import "core-js/modules/esnext.set.is-subset-of.v2.js";
import "core-js/modules/esnext.set.is-superset-of.v2.js";
import "core-js/modules/esnext.set.symmetric-difference.v2.js";
import "core-js/modules/esnext.set.union.v2.js";
import { defineComponent, h } from "vue";
import "@rei/cedar";
import "@rei/spinner";
import "@rei/cdr-tokens";
/* empty css                                                              */
/* empty css                                          */
import "../../components/MediaCenter/MediaCenterHeroImage/MediaCenterHeroImage.mjs";
/* empty css                                                                       */
/* empty css                                  */
/* empty css                                                             */
import "@rei/session";
const MediaCenterContainer = defineComponent({
  name: "MediaCenterContainer",
  mounted() {
    this.$store.commit(UPDATE_COMPONENT_MOUNTED, "MediaCenterContainer");
    this.$store.dispatch(INIT_PRODUCT_PAGE_MOUNT);
  },
  render() {
    const {
      getters,
      dispatch,
      commit
    } = this.$store;
    return h(_sfc_main, {
      ...getters.mediaCenterProps,
      onImageSelected: (data) => dispatch(HANDLE_MC_IMAGE_CLICK, data),
      onMetricsClick: (data) => dispatch(METRICS_CLICK, data),
      onVerticalCarouselVisible: (data) => commit(SET_USE_VERTICAL_ANIMATION, data),
      onHeroClick: (zoomButton) => dispatch(HANDLE_HERO_ZOOM_OPEN, { zoomButton }),
      onImageZoomClose: () => dispatch(HANDLE_HERO_ZOOM_CLOSE),
      onImageZoomChange: (data) => dispatch(HANDLE_HERO_ZOOM_IMAGE_CHANGE, data),
      onUgcImageClick: (data) => dispatch(HANDLE_UGC_IMAGE_CLICK, data),
      onUgcImageViewerSelect: (data) => commit(SET_CURRENT_UGC_PRODUCT, data)
    });
  }
});
export {
  MediaCenterContainer as default
};
//# sourceMappingURL=MediaCenterContainer.mjs.map
